document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll('.vr-slides');
    elements.forEach(function (ele) {
        ele.style.cursor = 'grab';

        let pos = { top: 0, left: 0, x: 0, y: 0 };
        let isDragging = false;

        const mouseDownHandler = function (e) {
            ele.style.cursor = 'grabbing';
            ele.style.userSelect = 'none';

            pos = {
                left: ele.scrollLeft,
                x: e.clientX,
            };

            isDragging = false;

            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        };

        const mouseMoveHandler = function (e) {
            const dx = e.clientX - pos.x;

            ele.scrollLeft = pos.left - dx;

            // If the mouse moves a certain distance, consider it as a drag
            if (Math.abs(dx) > 5) {
                isDragging = true;
            }
        };

        const mouseUpHandler = function (e) {
            ele.style.cursor = 'grab';
            ele.style.removeProperty('user-select');

            // If it was a drag, prevent the click event
            if (isDragging) {
                e.preventDefault();
            }
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);

        };

        ele.addEventListener('mousedown', mouseDownHandler);
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('.vr-modal');
    var videos = document.querySelectorAll('.vr-video');
    var btn_prev = modal.querySelector('.vr-modal-prev');
    var btn_next = modal.querySelector('.vr-modal-next');
    var modal_videos = document.querySelectorAll('.vr-modal-video');

    var currentVideoIndex = 0;

    videos.forEach((video, index) => {
        video.addEventListener('click', function() {
            pauseVideos();
            showVideoModal(index);
            var scrollToPosition = index * window.innerHeight;
            document.querySelector('.vr-modal-wrapper').scrollTop = scrollToPosition;
        })
    });

    btn_prev.addEventListener('click', function () {
        navigateVideos(-1);
    });

    btn_next.addEventListener('click', function () {
        navigateVideos(1);
    });

    modal.addEventListener('click', function(event) {
        if (!event.target.closest('.vr-modal-video') && !event.target.closest('.vr-modal-prev, .vr-modal-next, .vr-modal-muted, .vr-modal-unmuted')) {
            closeVideoModal();
        }
    });

    function showVideoModal(index) {
        currentVideoIndex = index;
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
        btn_prev.style.display = (currentVideoIndex === 0) ? "none" : "flex";
        btn_next.style.display = (currentVideoIndex === modal_videos.length - 1) ? "none" : "flex";
        modal_videos.forEach(function (video) {
            video.classList.remove("active");
        });
        modal_videos[index].classList.add("active")
    }

    function closeVideoModal() {
        playVideos();
        modal.style.display = 'none';
        document.body.style.removeProperty('overflow');
    }

    function navigateVideos(direction) {
        var newIndex = currentVideoIndex + direction;
        showVideoModal(newIndex);
    }
    function pauseVideos() {
        let pauseTargets = document.querySelectorAll('.vr-video video');
        pauseTargets.forEach(target => {
            target.pause();
        })
    }
    function playVideos() {
        let pauseTargets = document.querySelectorAll('.vr-video video');
        pauseTargets.forEach(target => {
            target.play();
        })
    }

    const observers = [];
  
    modal_videos.forEach((modalVideo) => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.querySelector('video').play();
                } else {
                    entry.target.querySelector('video').pause();
                }
            });
        }, { threshold: 0.8 }); // Adjust the threshold as needed (e.g., 0.8 for 80% visibility)
        
        observers.push(observer);
        observer.observe(modalVideo);
    });

    modal_videos.forEach((modalVideo) => {
        const video = modalVideo.querySelector('video');
        video.addEventListener('click', function() {
            if(video.paused) {
                video.play();
            }else {
                video.pause();
            }
        })
    });

    var modal_muted = this.documentElement.querySelector('.vr-modal-muted');
    var modal_unmuted = this.documentElement.querySelector('.vr-modal-unmuted');
    modal_muted.addEventListener('click', function() {
        this.style.display = "none";
        modal_unmuted.style.display = "block";
        modal_videos.forEach((video)=> {video.querySelector('video').muted = false})
    })
    modal_unmuted.addEventListener('click', function() {
        this.style.display = "none";
        modal_muted.style.display = "block";
        modal_videos.forEach((video)=> {video.querySelector('video').muted = true})
    })
  });

document.addEventListener("DOMContentLoaded", function() {
    const medias = document.querySelectorAll('video');
    medias.forEach((media) => {
        media.addEventListener("canplay", function() {
            this.parentElement.querySelector('.is-loading').style.display = "none";
        })
    })
})

